import { Locale } from "date-fns";
import { ptBR } from "date-fns/locale";

const PT_BR_LOCALIZE = ptBR.localize as NonNullable<Locale["localize"]>;

const SHORT_WEEKDAYS = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];

// date-fns spells the short weekday "sab" without the accent; the screens have always shown "sáb" (VS-1953)
export const PT_BR_DATE_LOCALE: Locale = {
    ...ptBR,
    localize: {
        ...PT_BR_LOCALIZE,
        day: (index, options) =>
            options?.width === "short" ? SHORT_WEEKDAYS[index] : PT_BR_LOCALIZE.day(index, options),
    },
};
